/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared';
import {
  TGetNewsListModel,
  IGetNewsListRequest,
  IMappers,
  IGetNewsListResponse,
  IGetNewsListResponseError,
  TGetNewsListResponse,
} from './types';

const defaultConfig: TGetNewsListModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'journal',
  pathApi: '/v2/get-news-list/',
  hostType: 'api',
} as TGetNewsListModel;

function createGetNewsListModel(parameters: IGetNewsListRequest): TGetNewsListModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetNewsListOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetNewsListRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetNewsList<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetNewsListOptions<TResponse200, TResponse400>): Promise<TResponse200 | TResponse400 | TGetNewsListResponse> {
  const { response, statusCode } = await httpApi.fetch(createGetNewsListModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNewsListResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetNewsListResponseError);
    }
  }

  return { response, statusCode } as TGetNewsListResponse;
}

export { defaultConfig, createGetNewsListModel, fetchGetNewsList };
